export default __webpack_public_path__ + "static/media/logo.7cbd1dcd.png";